import { render, staticRenderFns } from "./ButtonIco.vue?vue&type=template&id=66fd4bae&scoped=true"
import script from "./ButtonIco.vue?vue&type=script&lang=js"
export * from "./ButtonIco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fd4bae",
  null
  
)

export default component.exports